export const in_electron = isElectron();

function isElectron() {
  // Renderer process
  if (
    typeof window !== "undefined" &&
    typeof window.process === "object" &&
    window.process.type === "renderer"
  ) {
    return true;
  }

  // Main process
  if (
    typeof process !== "undefined" &&
    typeof process.versions === "object" &&
    !!process.versions.electron
  ) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
  ) {
    return true;
  }

  return false;
}

export const in_firefox = isFirefox();

function isFirefox(): boolean {
  return (
    typeof navigator !== "undefined" &&
    /firefox|FxiOS/i.test(navigator.userAgent)
  );
}

const platform = (): string => {
  // In renderer bundles, Vite's node polyfills (see vite.config.mjs) shadow
  // the module-scope `process` with a browser shim whose `platform` is
  // undefined. Electron's real Node process (with `nodeIntegration`) is still
  // reachable through `window.process`, so prefer it, then fall back to the
  // module-scope `process` (real in the Electron main process) and finally to
  // the browser's `navigator.platform`.
  if (
    typeof window !== "undefined" &&
    typeof window.process === "object" &&
    window.process.platform
  ) {
    return window.process.platform;
  }
  if (typeof process !== "undefined" && process.platform) {
    return process.platform;
  }
  return typeof navigator !== "undefined" ? navigator.platform : "";
};

// Each check accepts both the Node spelling (process.platform) and the
// browser spelling (navigator.platform).

export const in_windows = () => {
  const value = platform();
  return value === "win32" || value.includes("Win");
};

export const in_mac = () => {
  const value = platform();
  return value === "darwin" || value.includes("Mac");
};

export const in_linux = () => {
  const value = platform();
  return value === "linux" || value.includes("Linux");
};
